import Card from "components/Card";
import Page from "components/Page";
import React, { useEffect, useMemo, useRef, useState } from "react";
import constants from "../../../constants";
import { withTranslation } from "react-i18next";
import styles from "./PatientConversation.module.scss";
import useTeamConversationState from "Messenger/hooks/useTeamConversationState";
import useSelectedAccountOwner from "Messenger/hooks/useSelectedAccountOwner";
import { Redirect, useLocation } from "react-router-dom";
import MessageDot from "components/MessageDot";
import AppointmentListTable from "./component/AppointmentListTable";
import Loader from "components/Loader";
import InternalTabContent from "../TeamConversation/components/TabsContent/InternalTabContent";
import { setStorage } from "utils";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import useModuleDisplayOwner, {
  getModuleDisplayOwnerName,
} from "hooks/useModuleDisplayOwner";
import useChatNotificationDeepLink from "Messenger/hooks/useChatNotificationDeepLink";
const PatientConversation = ({ t }) => {
  const [currentChannel, setCurrentChannel] = useState(null);
  const [viewAppointmentCred, setViewAppointmentCred] = useState(null);
  const location = useLocation();
  const {selectedId}=useAccountOwnerCommon();
  const displayOwner = useModuleDisplayOwner();
  const doctorChatCheck = useMemo(
    () =>
      location.pathname === constants.routes.patientWithOwnerOrDoctorChatModule,
    [location.pathname]
  );
  const {
    state: { ownerData, selectedOwner, loadinOwnerData },
   } = useSelectedAccountOwner({
    localStorageKey:
      constants.localStorageKeys.selectedChatAccountOwnerForPatient,
    setCurrentChannel,
    isPatient: true,
    doctorChatCheck,
  });
  const preservedRef=useRef(null);
  useEffect(() => {
    if(selectedId) {
      if(!preservedRef.current) {
        preservedRef.current=selectedId
      }else if(preservedRef.current!==selectedId) {
        setCurrentChannel(null);
        preservedRef.current=selectedId
      }
    }
  }, [selectedId]);
  const { state, otherMethods } = useTeamConversationState({
    selectedOwner,
  });
  const { profile } = state;
  const { handleBack } = otherMethods;
  const { pinnedChannelUrl } = useChatNotificationDeepLink({
    setCurrentChannel,
  });

  useEffect(() => {
    setStorage("isFromPatientChat", true);
  }, []);

  let isStaff = false;
  if (profile?.role) {
    isStaff = profile.role.systemRole === constants.systemRoles.staff;
  }

  if (loadinOwnerData) {
    return <Loader />;
  }

  if (isStaff) {
    if (!profile?.isPatientChat) {
      return <Redirect to={"/"} />;
    }
  }
  const renderUi = () => {
    if (viewAppointmentCred) {
      return (
        <AppointmentListTable
          creds={viewAppointmentCred}
          doctorChatCheck={doctorChatCheck}
          close={() => setViewAppointmentCred(null)}
        />
      );
    }
    return (
      <div
        className={
          styles.patient_live_chat_page_content +
          " messenger-page-content scheduler-page"
        }
      >
        <Page onBack={handleBack}>
          <div className="d-md-flex justify-content-between scheduler-page page_title_margin_top">
            <h2 className="page-title mb-0 margin-fix">
              {t(
                `messenger.${
                  doctorChatCheck ? "doctorLiveChat" : "patientLiveChat"
                }`
              )}
            </h2>
          </div>
            {isStaff && ownerData?.length > 1 && displayOwner?.id && (
                  <div className="show-owner-name-text">
                    {t("messenger.selectedAccountOwnerText")}{" "}
                    <span>'{getModuleDisplayOwnerName(displayOwner)}'</span>
                    <MessageDot /> {t("dashBoard.office")}
                  </div>
                )}
          <Card
            radius="10px"
            marginBottom="18px"
            shadow="0 0 15px 0 rgba(0, 0, 0, 0.08)"
            cursor="default"
            padding="70px"
            className={styles.team_chat_card}
          >
            <div className="messenger-content">
              <InternalTabContent
                currentUser={profile}
                doctorChatCheck={doctorChatCheck}
                selectedOwner={selectedOwner}
                currentChannel={currentChannel}
                setCurrentChannel={setCurrentChannel}
                setViewAppointmentCred={setViewAppointmentCred}
                isFromPatientChat={true}
                pinnedChannelUrl={pinnedChannelUrl}
              />
            </div>
          </Card>
        </Page>
      </div>
    );
  };

  return renderUi();
};

export default withTranslation()(PatientConversation);
